import { render, staticRenderFns } from "./FamilyDonut.vue?vue&type=template&id=2eb9308b&scoped=true&"
import script from "./FamilyDonut.vue?vue&type=script&lang=js&"
export * from "./FamilyDonut.vue?vue&type=script&lang=js&"
import style0 from "./FamilyDonut.vue?vue&type=style&index=0&id=2eb9308b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb9308b",
  null
  
)

export default component.exports